export const CATEGORIES = [
  'MRT station',
  'Bus interchange',
  'Hawker center',
  'Restaurant',
  'Place of Interest',
  'Community Center',
  'Gym'
];
